const cityPostal = {
    "北京市": "100000",
    "上海市": "200000",
    "天津市": "300000",
    "重庆市": "400000",
    "山东省滨州市": "256600",
    "山东省德州市": "253000",
    "山东省东营市": "257000",
    "山东省菏泽市": "274000",
    "山东省济南市": "250000",
    "山东省济宁市": "272100",
    "山东省莱芜市": "271100",
    "山东省聊城市": "252000",
    "山东省临沂市": "276000",
    "山东省青岛市": "266000",
    "山东省日照市": "276800",
    "山东省泰安市": "271000",
    "山东省威海市": "264200",
    "山东省潍坊市": "261000",
    "山东省烟台市": "264000",
    "山东省枣庄市": "277100",
    "山东省淄博市": "255000",
    "福建省福州市": "350000",
    "福建省龙岩市": "364000",
    "福建省南平市": "353000",
    "福建省宁德市": "352100",
    "福建省莆田市": "351100",
    "福建省泉州市": "362000",
    "福建省三明市": "365000",
    "福建省厦门市": "361000",
    "福建省漳州市": "363000",
    "河北省保定市": "071000",
    "河北省沧州市": "061000",
    "河北省承德市": "067000",
    "河北省邯郸市": "056000",
    "河北省衡水市": "053000",
    "河北省廊坊市": "065000",
    "河北省秦皇岛市": "066000",
    "河北省石家庄市": "050000",
    "河北省唐山市": "063000",
    "河北省邢台市": "054000",
    "河北省张家口市": "075000",
    "河南省安阳市": "455000",
    "河南省鹤壁市": "458000",
    "河南省济源市": "454650",
    "河南省焦作市": "454000",
    "河南省开封市": "475000",
    "河南省洛阳市": "471000",
    "河南省漯河市": "462000",
    "河南省南阳市": "473000",
    "河南省平顶山市": "467000",
    "河南省濮阳市": "457000",
    "河南省三门峡市": "472000",
    "河南省商丘市": "476000",
    "河南省新乡市": "453000",
    "河南省信阳市": "464000",
    "河南省许昌市": "461000",
    "河南省郑州市": "450000",
    "河南省周口市": "466000",
    "河南省驻马店市": "463000",
    "湖北省鄂州市": "436000",
    "湖北省恩施州市": "445000",
    "湖北省黄冈市": "438000",
    "湖北省黄石市": "435000",
    "湖北省荆门市": "448000",
    "湖北省荆州市": "434100",
    "湖北省十堰市": "442000",
    "湖北省随州市": "441300",
    "湖北省武汉市": "430000",
    "湖北省咸宁市": "437000",
    "湖北省襄阳市": "441000",
    "湖北省孝感市": "432100",
    "湖北省宜昌市": "443000",
    "湖南省常德市": "415000",
    "湖南省郴州市": "423000",
    "湖南省衡阳市": "421000",
    "湖南省怀化市": "418000",
    "湖南省娄底市": "417000",
    "湖南省邵阳市": "422000",
    "湖南省湘潭市": "411100",
    "湖南省湘西州市": "416000",
    "湖南省益阳市": "413000",
    "湖南省永州市": "425000",
    "湖南省岳阳市": "414000",
    "湖南省张家界市": "427000",
    "湖南省长沙市": "410000",
    "湖南省株洲市": "412000",
    "海南省儋州市": "571700",
    "海南省海口市": "570000",
    "海南省三沙市": "573199",
    "海南省三亚市": "572000",
    "江西省抚州市": "344000",
    "江西省赣州市": "341000",
    "江西省吉安市": "343000",
    "江西省景德镇市": "333000",
    "江西省九江市": "332000",
    "江西省南昌市": "330000",
    "江西省萍乡市": "337000",
    "江西省上饶市": "334000",
    "江西省新余市": "336500",
    "江西省宜春市": "336000",
    "江西省鹰潭市": "335000",
    "黑龙江省大庆市": "163000",
    "黑龙江省大兴安岭地区市": "",
    "黑龙江省哈尔滨市": "150000",
    "黑龙江省鹤岗市": "154100",
    "黑龙江省黑河市": "164300",
    "黑龙江省鸡西市": "158100",
    "黑龙江省佳木斯市": "154000",
    "黑龙江省垦区市": "150036",
    "黑龙江省牡丹江市": "157000",
    "黑龙江省七台河市": "154600",
    "黑龙江省齐齐哈尔市": "161000",
    "黑龙江省双鸭山市": "155100",
    "黑龙江省绥化市": "152000",
    "黑龙江省伊春市": "153000",
    "贵州省安顺市": "561000",
    "贵州省毕节地区市": "551700",
    "贵州省贵阳市": "550000",
    "贵州省六盘水市": "553000",
    "贵州省黔东南州市": "556000",
    "贵州省黔南州市": "558000",
    "贵州省黔西南州市": "562400",
    "贵州省铜仁地区市": "554300",
    "贵州省遵义市": "563000",
    "陕西省安康市": "725000",
    "陕西省宝鸡市": "721000",
    "陕西省汉中市": "723000",
    "陕西省商洛市": "726000",
    "陕西省铜川市": "727000",
    "陕西省渭南市": "714000",
    "陕西省西安市": "710000",
    "陕西省咸阳市": "712000",
    "陕西省延安市": "716000",
    "陕西省榆林市": "719000",
    "新疆省阿克苏地区市": "843000",
    "新疆省阿勒泰地区市": "836500",
    "新疆省巴音郭楞蒙古自治州市": "841000",
    "新疆省博尔塔拉蒙古自治州市": "833400",
    "新疆省昌吉回族自治州市": "831100",
    "新疆省哈密地区市": "839000",
    "新疆省和田地区市": "848000",
    "新疆省喀什地区市": "844000",
    "新疆省克拉玛依市": "834000",
    "新疆省克孜勒苏柯尔克孜自治州市": "845350",
    "新疆省塔城地区市": "834700",
    "新疆省吐鲁番地区市": "838000",
    "新疆省乌鲁木齐市": "830000",
    "新疆省伊犁哈萨克自治州市": "835000",
    "江苏省常州市": "213000",
    "江苏省淮安市": "223200",
    "江苏省连云港市": "222000",
    "江苏省南京市": "210000",
    "江苏省南通市": "226000",
    "江苏省苏州市": "215000",
    "江苏省泰州市": "225300",
    "江苏省无锡市": "214000",
    "江苏省宿迁市": "223800",
    "江苏省徐州市": "221000",
    "江苏省盐城市": "224000",
    "江苏省扬州市": "225000",
    "江苏省镇江市": "212000",
    "安徽省安庆市": "246000",
    "安徽省蚌埠市": "233000",
    "安徽省亳州市": "236800",
    "安徽省巢湖市": "238000",
    "安徽省池州市": "247000",
    "安徽省滁州市": "239000",
    "安徽省阜阳市": "236000",
    "安徽省合肥市": "230000",
    "安徽省淮北市": "235000",
    "安徽省淮南市": "232000",
    "安徽省黄山市": "245000",
    "安徽省六安市": "237000",
    "安徽省马鞍山市": "243000",
    "安徽省铜陵市": "244000",
    "安徽省芜湖市": "241000",
    "安徽省宿州市": "234000",
    "安徽省宣城市": "242000",
    "西藏省阿里地区市": "859000",
    "西藏省昌都地区市": "854000",
    "西藏省拉萨市": "850000",
    "西藏省林芝地区市": "860000",
    "西藏省那曲地区市": "852000",
    "西藏省日喀则地区市": "857000",
    "西藏省山南地区市": "856000",
    "吉林省白城市": "137000",
    "吉林省白山市": "134300",
    "吉林省吉林市": "132000",
    "吉林省辽源市": "136200",
    "吉林省四平市": "136000",
    "吉林省松原市": "138000",
    "吉林省通化市": "134000",
    "吉林省延边市": "133000",
    "吉林省长春市": "130000",
    "甘肃省白银市": "730900",
    "甘肃省定西市": "743000",
    "甘肃省甘南州市": "747000",
    "甘肃省嘉峪关市": "735100",
    "甘肃省金昌市": "737100",
    "甘肃省酒泉市": "735000",
    "甘肃省兰州市": "730000",
    "甘肃省临夏州市": "731100",
    "甘肃省陇南市": "746000",
    "甘肃省平凉市": "744000",
    "甘肃省庆阳市": "745000",
    "甘肃省天水市": "741000",
    "甘肃省武威市": "733000",
    "甘肃省张掖市": "734000",
    "宁夏省固原市": "756000",
    "宁夏省石嘴山市": "753000",
    "宁夏省吴忠市": "751100",
    "宁夏省银川市": "750000",
    "宁夏省中卫市": "755000",
    "山西省大同市": "037000",
    "山西省晋城市": "048000",
    "山西省晋中市": "030600",
    "山西省临汾市": "041000",
    "山西省吕梁市": "033000",
    "山西省朔州市": "038500",
    "山西省太原市": "030000",
    "山西省忻州市": "034000",
    "山西省阳泉市": "045000",
    "山西省运城市": "044000",
    "山西省长治市": "046000",
    "四川省阿坝州市": "624000",
    "四川省巴中市": "636000",
    "四川省成都市": "610000",
    "四川省达州市": "635000",
    "四川省德阳市": "618000",
    "四川省甘孜州市": "626000",
    "四川省广安市": "638000",
    "四川省广元市": "628000",
    "四川省乐山市": "614000",
    "四川省凉山州市": "615000",
    "四川省泸州市": "646000",
    "四川省眉山市": "620010",
    "四川省绵阳市": "621000",
    "四川省南充市": "637000",
    "四川省内江市": "641000",
    "四川省攀枝花市": "617000",
    "四川省遂宁市": "629000",
    "四川省雅安市": "625000",
    "四川省宜宾市": "644000",
    "四川省资阳市": "641300",
    "四川省自贡市": "643000",
    "广西省百色市": "533000",
    "广西省北海市": "536000",
    "广西省北流市": "537400",
    "广西省崇左市": "532200",
    "广西省防城港市": "538000",
    "广西省贵港市": "537100",
    "广西省桂林市": "541000",
    "广西省河池市": "547000",
    "广西省贺州市": "542800",
    "广西省来宾市": "546100",
    "广西省柳州市": "545000",
    "广西省南宁市": "530000",
    "广西省钦州市": "535000",
    "广西省梧州市": "543000",
    "广西省玉林市": "537000",
    "浙江省杭州市": "310000",
    "浙江省湖州市": "313000",
    "浙江省嘉兴市": "314000",
    "浙江省金华市": "321000",
    "浙江省丽水市": "323000",
    "浙江省宁波市": "315000",
    "浙江省衢州市": "324000",
    "浙江省绍兴市": "312000",
    "浙江省台州市": "318000",
    "浙江省温州市": "325000",
    "浙江省舟山市": "316000",
    "云南省保山市": "678000",
    "云南省楚雄州市": "675000",
    "云南省大理州市": "671000",
    "云南省德宏州市": "678400",
    "云南省迪庆州市": "674400",
    "云南省红河州市": "661100",
    "云南省昆明市": "650000",
    "云南省丽江市": "674100",
    "云南省临沧市": "677000",
    "云南省怒江州市": "673200",
    "云南省普洱市": "665000",
    "云南省曲靖市": "655000",
    "云南省文山州市": "663099",
    "云南省西双版纳州市": "666100",
    "云南省玉溪市": "653100",
    "云南省昭通市": "657000",
    "内蒙古省阿拉善盟市": "750306",
    "内蒙古省巴彦淖尔市": "015000",
    "内蒙古省包头市": "014000",
    "内蒙古省赤峰市": "024000",
    "内蒙古省鄂尔多斯市": "017000",
    "内蒙古省呼和浩特市": "010000",
    "内蒙古省呼伦贝尔市": "021000",
    "内蒙古省通辽市": "028000",
    "内蒙古省乌海市": "016000",
    "内蒙古省乌兰察布市": "012000",
    "内蒙古省锡林郭勒盟市": "026000",
    "内蒙古省兴安盟市": "137400",
    "辽宁省大连市": "116000",
    "辽宁省金州市": "116100",
    "辽宁省瓦房店市": "116300",
    "辽宁省普兰店市": "116200",
    "辽宁省庄河市": "116400",
    "辽宁省长海县市": "116500",
    "辽宁省长兴岛市": "116318",
    "辽宁省鞍山市": "114000",
    "辽宁省本溪市": "117000",
    "辽宁省朝阳市": "122000",
    "辽宁省丹东市": "118000",
    "辽宁省抚顺市": "113000",
    "辽宁省阜新市": "123000",
    "辽宁省葫芦岛市": "125000",
    "辽宁省锦州市": "121000",
    "辽宁省辽阳市": "111000",
    "辽宁省盘锦市": "124000",
    "辽宁省沈阳市": "110000",
    "辽宁省铁岭市": "112000",
    "辽宁省营口市": "115000",
    "广东省潮州市": "521000",
    "广东省东莞市": "511700",
    "广东省佛山市": "528000",
    "广东省广州市": "510000",
    "广东省河源市": "517000",
    "广东省惠州市": "516000",
    "广东省江门市": "529000",
    "广东省揭阳市": "522000",
    "广东省茂名市": "525000",
    "广东省梅州市": "514000",
    "广东省清远市": "511500",
    "广东省汕头市": "515000",
    "广东省汕尾市": "516600",
    "广东省韶关市": "512000",
    "广东省深圳市": "518000",
    "广东省阳江市": "529500",
    "广东省云浮市": "527300",
    "广东省湛江市": "524000",
    "广东省肇庆市": "526000",
    "广东省中山市": "528400",
    "广东省珠海市": "519000",
    "青海省果洛州市": "814000",
    "青海省海北州市": "812200",
    "青海省海东地区市": "810699",
    "青海省海南州市": "813000",
    "青海省海西州市": "817000",
    "青海省黄南州市": "811300",
    "青海省西宁市": "810000",
    "青海省玉树州市": "815000"
  };


  export {cityPostal};